import { nodeNameToFactoryId } from "../compiler/utils/nodeNameToFactoryId";
import { CodeNodeDef } from "../parser/definition/types/CodeNodeDef";
import { CodeNode } from "./types/CodeNode";
import { getCodeNodeInputNames } from "./utils/getCodeNodeInputNames";
import { getCompilationTargetString } from "./utils/getCompilationTarget";
import { getModuleName } from "./utils/getModuleName";
import { getNodeName } from "./utils/getNodeName";

export function convertCodeNodeDefToLegacyOne(id: string, nodeName: string, node: CodeNodeDef<any, any>): CodeNode {
    let inputHandlers: any = {};
    const __init__ = "__init__";
    const __cleanup__ = "__cleanup__";

    for (let handler of Object.keys(node.inputHandlers)) {
        inputHandlers[handler] = {};
        inputHandlers[handler][getCompilationTargetString()] = "";
    }
    if (node.initHandler) {
        inputHandlers[__init__] = {};
        inputHandlers[__init__][getCompilationTargetString()] = "";
    }
    if (node.cleanupHandler) {
        inputHandlers[__cleanup__] = {};
        inputHandlers[__cleanup__][getCompilationTargetString()] = "";
    }

    return {
        id,
        name: getNodeName(nodeName),
        description: nodeName,
        code: inputHandlers,
        module: getModuleName(nodeName),
        inputNames: getCodeNodeInputNames(node),
        outputNames: node.outputNames.map((item) => item.toString()),
        dependencies: [],
        stateProperties: node.inputNames.map((item) => item.toString())
    }
}

